import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCurrentLanguageFromPath, getLanguageFromLocalStorage } from '../utils/languageDetection';
import es from '../locales/es.json';
import en from '../locales/en.json';
import pt from '../locales/pt.json';
import nl from '../locales/nl.json';

const resources = {
  es: {
    translation: es,
  },
  en: {
    translation: en,
  },
  pt: {
    translation: pt,
  },
  nl: {
    translation: nl,
  },
};

// Get language from URL path for SSR/initial load, but also check localStorage
const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const urlLanguage = getCurrentLanguageFromPath();

    if (urlLanguage && urlLanguage !== 'es') {
      return urlLanguage;
    }
    const savedLanguage = getLanguageFromLocalStorage();
    if (savedLanguage) {
      return savedLanguage;
    }

    return getCurrentLanguageFromPath();
  }
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    lng: getInitialLanguage(), // Use URL-based language detection
    debug: false, // Disable debug in production

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },

    initImmediate: typeof window !== 'undefined',

    load: 'languageOnly',
    cleanCode: true,

    saveMissing: false,
    updateMissing: false,
  });

export default i18n;
